// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"a648e6a6","196":"a24dcbb6","492":"a8f45b4b","628":"4f9a590c","840":"b10865e6","974":"6fcddd60"}[chunkId] + ".chunk.js";
};